import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {getClassName} from '../../../utils';

import './textInput.component.scss';


/**
 * TextInput
 */
class TextInput extends PureComponent {

    /**
     * Render Component
     * @return {XML}
     */
    render = () => {
        const {
            id,
            name,
            className,
            placeholder,
            type,
            value,
            disabled,
            error,
            errorMessage,
            maxLength,
            onChange,
            onKeyDown,
            onBlur,
            autoComplete,
            autoFocus,
            min,
            max
        } = this.props;

        const baseClassName = getClassName('text-input', [
            {condition: className, trueClassName: className},
            {condition: error, trueClassName: 'text-input--error'}
        ]);

        return (
            <div className={baseClassName}>
                <input
                    id={id}
                    name={name}
                    className='text-input_field'
                    placeholder={placeholder}
                    type={type}
                    value={value}
                    disabled={disabled}
                    maxLength={maxLength}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    autoComplete={autoComplete}
                    autoFocus={autoFocus}
                    min={min}
                    max={max}/>
                {error && errorMessage && errorMessage.length ?
                    <div className='text-input_error-container'>
                        <i className='text-input_error-container-icon q4i-warning-4pt'/>
                        <div className='text-input_error-container-message'>{error}</div>
                    </div> : null}
            </div>
        );
    }
}

TextInput.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    errorMessage: PropTypes.string,
    maxLength: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number
};

TextInput.defaultProps = {
    type: 'text',
    placeholder: '',
    value: '',
    disabled: false,
    autoComplete: 'off'
};

export default TextInput;